module.exports = __webpack_public_path__ + "media/images/views/dashboard/star-0d71599d5b3e223f119ba341ab2fff83.png";